"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustEducation = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var CustEducation = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CustEducation, _super);
    function CustEducation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷学历接口';
        _this.code = '101126';
        _this.desc = '现金贷学历接口';
        _this.requestParams = new cashLoanAuth_1.CustEducationRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CustEducation;
}(service_1.BaseService));
exports.CustEducation = CustEducation;
//# sourceMappingURL=custEducation.js.map